/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsReferences,
    SharedserviceMelcoModelsReferencesFromJSON,
    SharedserviceMelcoModelsReferencesFromJSONTyped,
    SharedserviceMelcoModelsReferencesToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsAlphabetReferences
 */
export interface SharedserviceMelcoModelsAlphabetReferences {
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsReferences>}
     * @memberof SharedserviceMelcoModelsAlphabetReferences
     */
    design_list?: Array<SharedserviceMelcoModelsReferences> | null;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsReferences>}
     * @memberof SharedserviceMelcoModelsAlphabetReferences
     */
    custom_product_list?: Array<SharedserviceMelcoModelsReferences> | null;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsReferences>}
     * @memberof SharedserviceMelcoModelsAlphabetReferences
     */
    alphabet_collection_list?: Array<SharedserviceMelcoModelsReferences> | null;
}

export function SharedserviceMelcoModelsAlphabetReferencesFromJSON(json: any): SharedserviceMelcoModelsAlphabetReferences {
    return SharedserviceMelcoModelsAlphabetReferencesFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsAlphabetReferencesFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsAlphabetReferences {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'design_list': !exists(json, 'design_list') ? undefined : (json['design_list'] === null ? null : (json['design_list'] as Array<any>).map(SharedserviceMelcoModelsReferencesFromJSON)),
        'custom_product_list': !exists(json, 'custom_product_list') ? undefined : (json['custom_product_list'] === null ? null : (json['custom_product_list'] as Array<any>).map(SharedserviceMelcoModelsReferencesFromJSON)),
        'alphabet_collection_list': !exists(json, 'alphabet_collection_list') ? undefined : (json['alphabet_collection_list'] === null ? null : (json['alphabet_collection_list'] as Array<any>).map(SharedserviceMelcoModelsReferencesFromJSON)),
    };
}

export function SharedserviceMelcoModelsAlphabetReferencesToJSON(value?: SharedserviceMelcoModelsAlphabetReferences | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'design_list': value.design_list === undefined ? undefined : (value.design_list === null ? null : (value.design_list as Array<any>).map(SharedserviceMelcoModelsReferencesToJSON)),
        'custom_product_list': value.custom_product_list === undefined ? undefined : (value.custom_product_list === null ? null : (value.custom_product_list as Array<any>).map(SharedserviceMelcoModelsReferencesToJSON)),
        'alphabet_collection_list': value.alphabet_collection_list === undefined ? undefined : (value.alphabet_collection_list === null ? null : (value.alphabet_collection_list as Array<any>).map(SharedserviceMelcoModelsReferencesToJSON)),
    };
}


